import React, {createContext, useState} from 'react';
import { API, defaultError, config, closeSession } from "../config";
import axios from "axios";
import useSWR from 'swr';

const MyRulesContext = createContext();

const MyRulesProvider = ({ children }) => {
    const [error, setError] = useState({"error": false, "message": ""});
    const [rule, setRule] = useState({"ruleTitle": "", "ruleDescription": ""});
    const [rules, setRules] = useState([]);
    const [sorters, setSorters] = useState({"sorter": "date", "order": "desc"});
    const [page, setPage] = useState(0);
    const [pageAdmin, setPageAdmin] = useState(0);
    const [maxPage, setMaxPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [ruleId, setRuleId] = useState(0);

    const fetcher = () => axios.get(`${API}/rules/getallrules/${sorters.sorter}/${sorters.order}/${page}`).then(res => {
        setMaxPage(res.data.maxPage);
        return res.data.response
    });

    function useRules () {
        const {data, error} = useSWR(`${API}/rules/getallrules/${sorters.sorter}/${sorters.order}/${page}`, fetcher);
        return {
            rules: data,
            isLoading: !error && !data,
            isError: error
        }
    }

    const getRulesAdmin = async () => {
        setError({"error": false, "message": ""});
        setLoading(true)
        await axios.get(`${API}/rules/rules/${pageAdmin}`, config).then(res => {
            if(res.data.error){
                if(res.data.status == "400-1"){
                    closeSession();
                }
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({"error": true, "message": res.data.response});
                return;
            }
            setMaxPage(res.data.maxPage);
            setRules(res.data.response);
        }).catch(err=>{
            setError(defaultError);
        })
        setLoading(false);
    }

    const getFile = async (filePath, ruleTitle, ruleId) => {
        setLoading(true);
        setRuleId(ruleId);
        await axios.get(`${API}/rules/getfile/${filePath}`).then(res => {
            setError({"error": false, "message": ""});
            if(res.data.error){
                setLoading(false);
                //seterror and put false after 3 seconds
                setError({"error": true, "message": res.data.response});
                setTimeout(() => {
                    setError({"error": false, "message": ""});
                }, 3000);
                return;
            }
            const binaryString = window.atob(res.data.response);
            const bytes = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            const url = window.URL.createObjectURL(new Blob([bytes], {type: 'application/pdf'}));

            const link = document.createElement('a');
            link.href = url;
            //link.setAttribute('download', filePath);
            link.setAttribute('download', ruleTitle.replace(".", ""));
            document.body.appendChild(link);
            link.click();
            setLoading(false)
        }).catch(err => {
            setLoading(false)
            setError({"error": true, "message": "Ha ocurrido un error al descargar el archivo"});
            setTimeout(() => {
                setError({"error": false, "message": ""});
            }, 3000);
        });
    }

    const addRule = async (data)=>{
        
        setLoading(true);
        var formData = new FormData();
        formData.append("ruleFile", data.ruleFile[0]);
        formData.append("ruleTitle", data.ruleTitle);
        formData.append("ruleDescription", data.ruleDescription);
        formData.append("ruleCreationDate", data.ruleCreationDate.toString());

        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.post(`${API}/rules/addrule`, formData, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getRulesAdmin();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const updateRule = async (data, ruleId)=>{
        setLoading(true);
        var formData = new FormData();
        formData.append("ruleFile", data.ruleFile.length > 0 ? data.ruleFile[0] : new File([], "empty"));
        formData.append("ruleTitle", data.ruleTitle);
        formData.append("ruleDescription", data.ruleDescription);
        formData.append("ruleCreationDate", data.ruleCreationDate.toString());

        config.headers["Content-Type"] = "multipart/form-data";
        try{
            const res = await axios.put(`${API}/rules/updaterule/${ruleId}`, formData, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getRulesAdmin();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    const changeRuleVisibility = async(ruleId) => {
        try{
            const res = await axios.put(`${API}/rules/changerulevisibility/${ruleId}`, {}, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getRulesAdmin();
            }
            return res.data;
        } catch(err){
            return defaultError;
        }
    }

    const deleteRule = async(ruleId) => {
        setLoading(true);
        try{
            const res = await axios.delete(`${API}/rules/deleterule/${ruleId}`, config)
            if(res.data.status == "400-1"){
                closeSession();
            }
            if(!res.data.error){
                getRulesAdmin();
            }
            setLoading(false);
            return res.data;
        } catch(err){
            setLoading(false);
            return defaultError;
        }
    }

    return (
        <MyRulesContext.Provider value={{
            error,
            rule,
            setRule,
            sorters,
            setSorters,
            maxPage,
            setPage,
            useRules,
            getFile,
            setPageAdmin,
            pageAdmin,
            changeRuleVisibility,
            getRulesAdmin,
            rules,
            loading,
            deleteRule,
            addRule,
            setError,
            updateRule,
            ruleId
        }}>
            {children}
        </MyRulesContext.Provider>
    );
}

export { MyRulesProvider };
export default MyRulesContext;